var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWavePattern2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1441,
    height: 405,
    viewBox: "0 0 1441 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2933_6381)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-12.9363 126.439C-199.763 -49.6339 -640.663 -91.0994 -837.76 -89.8231C-997.335 -103.204 -1316.29 -65.1215 -1315.49 194.256C-1314.49 518.477 -602.464 483.585 -311.213 778.211C-78.2121 1013.91 728.939 1020.24 1103.39 993.948C1311.59 973.75 1718.47 885.96 1680.35 696.376C1642.22 506.793 1218.8 431.852 1011.86 418.08C748.105 394.23 173.89 302.512 -12.9363 126.439Z",
    fill: "#FCF9ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M430.66 131.79C243.834 -44.2823 -197.066 -85.7479 -394.163 -84.4715C-553.739 -97.8524 -872.69 -59.77 -871.892 199.607C-870.895 523.829 -158.868 488.937 132.384 783.563C365.385 1019.26 1172.54 1025.6 1546.99 999.299C1755.19 979.102 2162.07 891.311 2123.94 701.728C2085.82 512.145 1662.4 437.204 1455.46 423.432C1191.7 399.582 617.487 307.863 430.66 131.79Z",
    fill: "#FCF9ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1086.74 187.309C1399.78 87.4807 1818.54 177.118 1988.8 234.416C2138.97 268.273 2383.67 392.31 2161.09 617.6C1882.87 899.214 1293.72 665.895 788.483 839.032C384.294 977.542 -322.817 752.948 -625.848 623.337C-789.572 546.422 -1068.19 354.1 -872.866 200.133C-677.541 46.1666 -245.337 101.715 -53.6499 148.735C196.046 203.189 773.699 287.138 1086.74 187.309Z",
    fill: "#FCF9ED"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M611.142 300.432C924.181 200.604 1342.95 290.241 1513.2 347.539C1663.37 381.396 1908.08 505.433 1685.5 730.724C1407.27 1012.34 818.125 779.018 312.888 952.155C-91.3007 1090.66 -798.411 866.071 -1101.44 736.46C-1265.17 659.545 -1543.78 467.223 -1348.46 313.256C-1153.14 159.29 -720.931 214.838 -529.245 261.858C-279.548 316.312 298.104 400.261 611.142 300.432Z",
    fill: "#FCF9ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2933_6381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440.64,
    height: 404.171,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavePattern2);
export default __webpack_public_path__ + "static/media/wave-pattern-2.56d935efb9a46547952f9aaed5e9529e.svg";
export { ForwardRef as ReactComponent };